export default "__VITE_ASSET__fAfKUvr7__"